import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/Home'
import Partner from '@/page/Partner'
import About from '@/page/About'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/partner',
      name: 'partner',
      component: Partner
    },
    {
      path: '/about',
      name: 'about',
      component: About
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js